export const handleApiError = (error: any, defaultMessage: string) => {
  return {
    success: false,
    message:
      error?.response?.data?.errors?.[0]?.description ||
      error?.response?.data?.error?.description ||
      error?.response?.data?.message ||
      error?.response?.message ||
      defaultMessage,
    data: error?.response?.data?.errors || error?.response?.data?.error,
  };
};
